// extracted by mini-css-extract-plugin
export var avatarContainer = "_gn-0";
export var avatarTypingWave = "_gn-i";
export var gray = "_gn-f";
export var green = "_gn-c";
export var icon = "_gn-9";
export var image = "_gn-1";
export var lg = "_gn-6";
export var md = "_gn-5";
export var presenceDot = "_gn-b";
export var red = "_gn-d";
export var sm = "_gn-4";
export var status = "_gn-a";
export var typingDot = "_gn-h";
export var typingPill = "_gn-g";
export var xl = "_gn-7";
export var xs = "_gn-3";
export var xxl = "_gn-8";
export var xxs = "_gn-2";
export var yellow = "_gn-e";